<template>
  <div  style="z-index: 10;background:#fff">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">修改密码</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <p class="error-info" v-if="errorMsg.show">{{errorMsg.msg}}</p>
      <div class="login">
        <ul class="login-form">
          <li><i class="ico-password"></i><input v-model="pwd" type="password" placeholder="请输入新密码"></li>
          <li><i class="ico-password"></i><input v-model="confirmPwd" class="inp" type="password" placeholder="请再次输入新密码"></li>
        </ul>
        <button type="button" class="login-btn" @click="validate">保 存</button>
      </div>
     </section>
    <!-- <div class="login">
      <ul>
        <li>
          <label>设置新密码</label>
          <div>
            <input v-model="pwd" class="inp" type="password" placeholder="请输入新密码" />
          </div>
        </li>
        <li>
          <label>确认信密码</label>
          <div>
            <input v-model="confirmPwd" class="inp" type="password" placeholder="请输入密码" />
          </div>
        </li>
      </ul>

      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">确定</button>
      </div>
    </div> -->

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>{{changed ? '密码更新成功' : '密码更新失败，请稍后重试'}}</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../../../services/userService'

export default {
  name: 'change-password',
  data () {
    return {
      pwd: '',
      confirmPwd: '',
      errorMsg: {
        show: false,
        msg: ''
      },
      showModal: false,
      changed: true
    }
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    validate () {
      if (this.pwd === '') {
        this.errorMsg = { show: true, msg: '请输入密码' }
      } else if (this.confirmPwd === '') {
        this.errorMsg = { show: true, msg: '请确认密码' }
      } else if (this.pwd !== this.confirmPwd) {
        this.errorMsg = { show: true, msg: '密码不一致，请确认' }
      } else {
        this.errorMsg = { show: false, msg: '' }
        this.changePwd()
      }
    },
    changePwd () {
      userService.changePwd(this.pwd).then(res => {
        if (res.result) {
          userService.updateUserInfo()
          this.changed = true
          this.showModal = true
        } else {
          this.errorMsg = { show: true, msg: res.msg }
        }
      })
    },
    hideModal () {
      const obj = document.getElementById('confirm-modal')
      obj.style.opacity = 1
      this.slideOut(obj)
    },
    slideOut (obj) {
      obj.style.opacity -= 0.05
      if (obj.style.opacity > 0) {
        setTimeout(() => {
          this.slideOut(obj)
        }, 15)
      } else {
        this.showModal = false
        this.$router.isBack = true
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
